import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { api } from './http/api/api'
import ECharts from 'vue-echarts' // 在 webpack 环境下指向 components/ECharts.vue
import theme from "echarts/theme/shine.js";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import 'echarts/lib/component/tooltip';
//新增
import 'echarts/lib/component/polar';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title.js';

import './assets/font/HFDigits.ttf';

import 'echarts-gl';
import 'swiper/dist/css/swiper.min.css'
import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper);



import {
  Button,
  Table,
  Page,
  Input,
  Icon,
  Spin,
  Notice,
  Message,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuGroup,
  Breadcrumb,
  BreadcrumbItem,
  Modal,
  Form,
  FormItem,
  CheckboxGroup,
  Checkbox,
  RadioGroup,
  Radio,
  Switch,
  Select,
  Option,
  Upload,
  Row,
  Col,
  DatePicker,
  Transfer,
  Carousel,
  CarouselItem,
  TimePicker,
  Poptip
} from 'view-design';
// 自定义全局组件
import Modal_primary from "./components/Modal_primary.vue";
import vImage from "./components/Image.vue";

import 'view-design/dist/styles/iview.css';
import './util/css/icon/iconfont.css';
import Local from './util/common/local'; // local封装函数
import { timeStamp } from './util/common/date'; // 时间函数

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
// Vue.use(QRCode)
Vue.component('i-button', Button);
Vue.component('i-table', Table);
Vue.component('i-input', Input);
Vue.component('Icon', Icon);
Vue.component('Spin', Spin);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Menu', Menu);
Vue.component('Submenu', Submenu);
Vue.component('MenuItem', MenuItem);
Vue.component('MenuGroup', MenuGroup);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('BreadcrumbItem', BreadcrumbItem);
Vue.component('Page', Page);
Vue.component('Modal', Modal);
Vue.component('Form', Form);
Vue.component('FormItem', FormItem);
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Checkbox', Checkbox);
Vue.component('RadioGroup', RadioGroup);
Vue.component('Radio', Radio);
Vue.component('i-switch', Switch);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('Upload', Upload);
Vue.component('Row', Row);
Vue.component('i-col', Col);
Vue.component('DatePicker', DatePicker);
Vue.component('Transfer', Transfer);
Vue.component('Carousel', Carousel);
Vue.component('CarouselItem', CarouselItem);
Vue.component('TimePicker', TimePicker); // 时间选择器
Vue.component('Poptip', Poptip); // 

Vue.component('v-chart', ECharts); // 全局组件
Vue.component('alert-p', Modal_primary); // 对话框
Vue.component('vImage', vImage); // 图片懒加载


Vue.config.productionTip = false
Vue.prototype.$api = api; // http请求api
Vue.prototype.$Notice = Notice; // 警告提示框 大
Vue.prototype.$Message = Message; // 警告提示框 小
Vue.prototype.$Local = Local; // h5本地缓存local的封装对象
Vue.prototype.$timeStamp = timeStamp; // 时间转换工具

function removeUrlParameter(url, parameter) {
  let urlObj = new URL(url);
  urlObj.searchParams.delete(parameter);
  return urlObj.toString();
}

router.beforeEach((to, from, next) => {
  //console.dir(to);
  let user = Local.getLocal("user", "object");
  if (!user && to.path != "/" && to.path != "/system/monitor") {
    next({ path: '/' })
    return;
  } else if (to.path == "/" && user) {
    if (user.userType == "PARK_MANAGER" || user.userType == "SUPER_MANAGER") {
      next({ path: '/home' })
      return;
    } else {
      next({ path: '/chome' })
    }
  } else {
    next();
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')